import React, {Fragment, useEffect} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {PillButton} from "../common/PillButton";
import {Constants} from "../common/Constants";
import {SelectUtility} from "../common/SelectUtility";
import Select from 'react-select';
import _ from "lodash";

export const FpServiceTypeForm = function (props) {
    let fpServiceType = _.clone(props.fpServiceType) || {};

    const fetchSupportingData = function () {
        return ApiUtility.getQboAccountsList()
            .then(function (qboAccounts) {
                return Promise.resolve({
                    supportingData: {
                        qboAccountOptions: SelectUtility.modelArrayToSelectOptions(qboAccounts)
                    }
                });
            })
    }

    const formEngine = useModelFormEngine(
        initialModelStateFromProps(),
        fpServiceType,
        fetchSupportingData,
        validateForm,
        formStateToSaveData,
        props.save
    );

    function initialModelStateFromProps() {
        const fpServiceType = _.clone(props.fpServiceType) || {};
        const blurb = `By default, the system will assign this account to "${fpServiceType.name}" QBO invoice lines it creates. Accounts set below for individual FP services override this default.`;

        let initialModelState = {
            id: fpServiceType.id,
            default_ext_qbo_income_account_id: fpServiceType.default_ext_qbo_income_account_id,
            showExpenseAccountField: false,
            blurb: blurb
        };

        if (fpServiceType && fpServiceType.name === Constants.fpServiceTypeNames.externalExpense) {
            initialModelState.showExpenseAccountField = true;
            initialModelState.default_ext_qbo_expense_account_id = fpServiceType.default_ext_qbo_expense_account_id
        }
        return initialModelState
    }

    useEffect(() => {
        formEngine.renderableData.updateAndRender(initialModelStateFromProps())
    }, [props.fpServiceType && props.fpServiceType.id]);

    function validateForm(handleValidationResult) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    if (!formEngine.renderableData.default_ext_qbo_income_account_id) {
                        validationErrors.push('Please select a default QBO income account.');
                        invalidFields.push('default_ext_qbo_income_account_id');
                    }

                    if (
                        formEngine.renderableData.showExpenseAccountField &&
                        !formEngine.renderableData.default_ext_qbo_expense_account_id
                    ) {
                        validationErrors.push('Please select a default QBO expense account.');
                        invalidFields.push('default_ext_qbo_expense_account_id');
                    }

                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    function formStateToSaveData(formStateToTransform) {
        let saveData = {id: formStateToTransform.id};
        saveData.default_ext_qbo_income_account_id = formStateToTransform.default_ext_qbo_income_account_id;
        if (formEngine.renderableData.showExpenseAccountField) {
            saveData.default_ext_qbo_expense_account_id = formStateToTransform.default_ext_qbo_expense_account_id;
        }
        return saveData;
    }

    function handleQboAccountChange(fieldName, option) {
        formEngine.updateAndRenderUnsavedData({[fieldName]: option.value});
    }

    return (
        <Fragment>
            <ConditionalRenderer
                if={formEngine.renderableData.showOverlayLoadingIndicator || !formEngine.renderableData.supportingData}
                renderer={() => (
                    <div className="sub-form-loading-indicator-container">
                        <OverlayLoadingIndicator/>
                    </div>
                )}
            />
            <ConditionalRenderer if={formEngine.renderableData.supportingData} renderer={() => {
                return (
                    <div className="common-form fp-service-type-form">
                        <div className="common-form-body">
                            <div className="common-form-body-row qbo-account-select-row">
                                <div
                                    className={formEngine.getFormFieldClasses("common-form-field", "default_ext_qbo_income_account_id")}>
                                    <div
                                        className="common-form-field-label"
                                        title={formEngine.renderableData.blurb}
                                    >
                                        Default QBO Income Account
                                    </div>
                                    <div className="common-form-field-input-container">
                                        <Select
                                            className="common-form-select qbo-account-select fp-service-type-income-account-select"
                                            classNamePrefix="common-form-select"
                                            value={SelectUtility.selectOptionForId(
                                                formEngine.renderableData.default_ext_qbo_income_account_id,
                                                formEngine.renderableData.supportingData.qboAccountOptions
                                            )}
                                            onChange={(option) => handleQboAccountChange(
                                                'default_ext_qbo_income_account_id',
                                                option
                                            )}
                                            options={formEngine.renderableData.supportingData.qboAccountOptions}
                                        />
                                    </div>
                                </div>
                            </div>

                            <ConditionalRenderer
                                if={formEngine.renderableData.showExpenseAccountField}
                                renderer={() => (
                                    <div className="common-form-body-row qbo-account-select-row">
                                        <div
                                            className={formEngine.getFormFieldClasses("common-form-field", "default_ext_qbo_expense_account_id")}>
                                            <div
                                                className="common-form-field-label"
                                                title={formEngine.renderableData.blurb}
                                            >
                                                Default QBO Expense Account
                                            </div>
                                            <div className="common-form-field-input-container">
                                                <Select
                                                    className="common-form-select qbo-account-select fp-service-type-expense-account-select"
                                                    classNamePrefix="common-form-select"
                                                    value={SelectUtility.selectOptionForId(
                                                        formEngine.renderableData.default_ext_qbo_expense_account_id,
                                                        formEngine.renderableData.supportingData.qboAccountOptions
                                                    )}
                                                    onChange={(option) => handleQboAccountChange(
                                                        'default_ext_qbo_expense_account_id',
                                                        option
                                                    )}
                                                    options={formEngine.renderableData.supportingData.qboAccountOptions}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            />

                            <div className="common-form-body-row">
                                <div className="common-form-options">
                                    <PillButton
                                        onClick={formEngine.onClickSave}
                                        containerClasses="common-form-button-container"
                                        buttonClasses="common-form-button save-button"
                                        buttonText={"SAVE"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}/>
        </Fragment>
    );
}
